import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

export default function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-1 rounded-full border border-gray-200 dark:border-gray-700 p-1 bg-gray-100/50 dark:bg-gray-800/50">
      <button
        type="button"
        aria-label="Mode clair"
        onClick={() => setTheme('light')}
        className={`p-1.5 rounded-full transition ${
          theme === 'light'
            ? 'bg-white text-primary-600 shadow-sm dark:bg-gray-700'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
        }`}
      >
        <Sun className="w-4 h-4" />
      </button>
      <button
        type="button"
        aria-label="Mode sombre"
        onClick={() => setTheme('dark')}
        className={`p-1.5 rounded-full transition ${
          theme === 'dark'
            ? 'bg-white text-primary-600 shadow-sm dark:bg-gray-700'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
        }`}
      >
        <Moon className="w-4 h-4" />
      </button>
      <button
        type="button"
        aria-label="Mode automatique"
        onClick={() => setTheme('system')}
        className={`p-1.5 rounded-full transition ${
          theme === 'system'
            ? 'bg-white text-primary-600 shadow-sm dark:bg-gray-700'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
        }`}
        title={`Actuellement ${resolved === 'dark' ? 'sombre' : 'clair'}`}
      >
        <Monitor className="w-4 h-4" />
      </button>
    </div>
  );
}
